export const SEARCH_TERM_PAGE_SIZE = 50
